import { Cluster, ClusterDisplayStatus } from '@cast/types';

const NON_SELECTABLE_STATUSES = new Set<ClusterDisplayStatus>([
  ClusterDisplayStatus.NOT_FOUND,
  ClusterDisplayStatus.DELETED,
  ClusterDisplayStatus.DELETING,
  ClusterDisplayStatus.ARCHIVED,
]);

/** Clusters that can be chosen in the OneClick header ClusterSelect. */
export const filterSelectableClusters = (clusters: Cluster[]): Cluster[] =>
  clusters.filter(
    (cluster) => !NON_SELECTABLE_STATUSES.has(cluster.displayStatus)
  );
